import React from "react";
import Layout from "../../common/components/layout";

const ResourcesPage = () => {
  return <Layout>{/* <ResourcesTab /> */}</Layout>;
};

export default ResourcesPage;
